import { SettingConst } from '../../types';

/**
 * Enable UK phone support for help center
 */
export const HELP_CENTER_PHONE_UK_250108 =
  'HELP_CENTER_PHONE_UK_250108' as SettingConst<
    'HELP_CENTER_PHONE_UK_250108',
    boolean,
    'HELP_CENTER'
  >;
